<template>
  <div class="wrapper">
    <div class="container-left">
      <!-- Left column -->
      <div v-if="showLeft" class="column-left">
        <slot name="left"></slot>
      </div>
      <!-- Middle column -->
      <div v-if="showMiddle" class="column-middle" :class="{ 'left-hidden': !showLeft }">
        <slot name="middle"></slot>
      </div>
      <!-- Right column -->
    </div>
    <div class="container-right">
      <div v-if="showRight" class="column-right">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
withDefaults(
  defineProps<{
    showLeft?: boolean
    showRight?: boolean
    showMiddle?: boolean
  }>(),
  {
    showLeft: true,
    showRight: true,
    showMiddle: true
  }
)
</script>
<style lang="scss" scoped>
.wrapper {
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  gap: 24px;
  justify-content: space-between;
  width: 100%;
}

.container-left {
  align-items: center;
  display: flex;
  flex-direction: row;
  max-width: 430px;
  padding-left: 2px;
}

.container-right {
  display: flex;
  flex-direction: row;
  flex-shrink: 1;
  padding-top: 5px;
  padding-right: 2px;
}

.column-left {
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-grow: 0.05;
  gap: 4px;
  transition: all 200ms linear;
}

.column-middle {
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-shrink: 1;
  transition: all 200ms linear;
  &:not(.left-hidden) {
    margin-left: 8px;
  }
}

.column-right {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 4px;
  transition: all 200ms linear;
}
.hidden {
  flex: 0.00001;
}
</style>
